import React from "react";
import ReactDOM from "react-dom";

import App from "./components/App";


//Renders the App component, and renders it in public/index.html because we have an element (div) in the index.html file that has id="root"
ReactDOM.render(<App />, document.getElementById("root"));
